<template>
  <el-config-provider :locale="locale">
    <router-view />
  </el-config-provider>
</template>

<script>
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
export default {
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
  },
  setup() {
    return {
      locale: zhCn,
    };
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    display: none;
  }
}
html,
body {
  height: 100%;
  background: #f6f6f6;
}
#app {
  font-family: PingFangSC-Medium, PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  height: 100%;
  white-space: pre-line;
}

svg {
  width: 20px;
}

.el-cascader-panel {
  height: 200px;
}

.el-dialog {
  font-size: 20px;
  .el-dialog__header {
    border-bottom: 1px solid #dcdfe6;
  }
}

.el-message {
  .el-icon,
  .el-icon svg {
    font-size: 20px;
  }
}

.el-radio-group {
  vertical-align: middle;
}
@media print {
  body {
    background: red;
  }
}
</style>
